"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Wind, Gauge, Zap, Activity, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
const services = [{
  title: "01 / LOFT CONVERSION",
  description: "Dormer Loft Conversion: Bespoke dormer and mansard conversions designed to maximize vertical space and natural light in North West London.",
  icon: Wind
}, {
  title: "02 / HOME EXTENSIONS",
  description: "Home Extensions: Seamless architectural additions that expand your living footprint while maintaining structural integrity and design flow.",
  icon: Gauge
}, {
  title: "03 / KITCHEN RENOVATION",
  description: "Kitchen Renovation: High-end culinary spaces featuring minimalist aesthetics, premium industrial finishes, and raw concrete elements.",
  icon: Zap
}, {
  title: "04 / STRUCTURAL ENGINEERING",
  description: "Structural Engineering: Expert engineering for complex residential projects, ensuring safety and longevity in every concrete and glass build.",
  icon: Activity
}, {
  title: "05 / PROJECT MANAGEMENT",
  description: "Project Management: Comprehensive oversight from initial concept to final handover, ensuring construction timelines and budgets are met.",
  icon: ShieldCheck
}];
export default function OurServices() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return;
}